/**
 * Exporta filas a un CSV que Excel abre correctamente:
 *  - BOM UTF-8 para que respete tildes/ñ.
 *  - Separador `;` (Excel en configuración regional es-CO usa `;`).
 *  - Comillas escapadas según RFC 4180.
 */
export function downloadCsv(
  filename: string,
  headers: string[],
  rows: ReadonlyArray<ReadonlyArray<string | number>>,
): void {
  const esc = (v: string | number): string => {
    const s = String(v ?? '');
    return /[",;\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const lines = [
    headers.map(esc).join(';'),
    ...rows.map((r) => r.map(esc).join(';')),
  ];
  const csv = '﻿' + lines.join('\r\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}
